export default [
    {
        name: "Сервисы",
        children: [
            {
                name: "Новости",
                icon: 'b-icon-newspaper',
                path: "/service/news"
            },
            {
                name: "Настройки",
                icon: 'b-icon-gear',
                path: "/service/settings"
            },
            {
                name: "Оценки покупок",
                icon: 'b-icon-star-fill',
                path: "/service/ratings"
            },
            {
                name: "Заказы",
                icon: 'b-icon-cart4',
                path: "/service/shop-orders"
            },
            {
                name: "Акции и подборки товаров",
                icon: 'b-icon-cart4',
                path: "/service/promotions"
            },
            {
                name: "Синонимы",
                icon: 'b-icon-files',
                path: "/service/synonyms"
            },
        ]
    }
]
